import clsx from 'clsx'

import Carousel from '@/atoms/Carousel/Carousel'
import { LogoSlide, TestimonialSlide, UspSlide } from './Slides'
import { testimonials } from './utils'

/* styling */
import styles from './_.module.css'

function OrderCarousel(): JSX.Element {
  return (
    <Carousel
      className={clsx(
        'flex items-center justify-center flex-col | h-full overflow-hidden | mx-auto',
        styles.container
      )}
      autoScroll={true}
      slides={[
        <UspSlide key={1} />,
        <TestimonialSlide key={2} testimonial={testimonials[0]} />,
        <TestimonialSlide key={3} testimonial={testimonials[1]} />,
        <LogoSlide key={4} />
      ]}
    />
  )
}

export default OrderCarousel
